'use strict';

exports.BackgroundPlateView = void 0;
(function (BackgroundPlateView) {
    BackgroundPlateView["Primary"] = "primary";
    BackgroundPlateView["Secondary"] = "secondary";
    BackgroundPlateView["Colored"] = "colored";
    BackgroundPlateView["Dropzone"] = "drop-zone";
    BackgroundPlateView["DropzoneSecondary"] = "drop-zone-secondary";
})(exports.BackgroundPlateView || (exports.BackgroundPlateView = {}));
